import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c0dabd0a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "disclaimer"
};
const _hoisted_2 = {
  class: "content"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " Мы используем файлы cookie и сервисы сбора технических данных посетителей для улучшения качества обслуживания. ", -1));

const _hoisted_4 = {
  class: "button-wrap"
};
const _hoisted_5 = {
  class: "footer"
};
const _hoisted_6 = {
  key: 0,
  class: "footer-banner"
};
const _hoisted_7 = {
  class: "holder"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-banner-title"
}, " Присоединяйтесь к сообществу коллекционеров ", -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-banner-text"
}, " Вы можете подать заявку на вступление в закрытое сообщество коллекционеров ", -1));

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Узнать больше ");

const _hoisted_11 = {
  class: "footer-top"
};
const _hoisted_12 = {
  class: "holder holder-fluid"
};
const _hoisted_13 = {
  class: "footer-top-block"
};
const _hoisted_14 = {
  class: "row"
};
const _hoisted_15 = {
  class: "buttons"
};
const _hoisted_16 = {
  class: "auth"
};
const _hoisted_17 = {
  class: "row",
  style: {
    "margin-top": "30px",
    "font-size": "15px"
  }
};
const _hoisted_18 = {
  class: "footer-nav"
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Авторы ");

const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Работы ");

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Подборки ");

const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Купить ");

const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Продать ");

const _hoisted_24 = /*#__PURE__*/_createTextVNode(" О нас ");

const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Контакты ");

const _hoisted_26 = {
  class: "phone"
};
const _hoisted_27 = {
  href: "tel:88001019046"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "8 800 101-90-46", -1));

const _hoisted_29 = {
  class: "buttons-mobile"
};
const _hoisted_30 = {
  class: "auth"
};
const _hoisted_31 = {
  class: "footer-bottom"
};
const _hoisted_32 = {
  class: "holder holder-fluid"
};
const _hoisted_33 = {
  class: "footer-bottom-block"
};
const _hoisted_34 = {
  class: "footer-copy"
};

const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "footer-links"
}, [/*#__PURE__*/_createElementVNode("a", {
  href: "/agreement",
  target: "_blank"
}, "Пользовательское соглашение")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_logo_icon = _resolveComponent("logo-icon");

  const _component_login_button_component = _resolveComponent("login-button-component");

  const _component_registration_button_component = _resolveComponent("registration-button-component");

  const _component_phone_icon = _resolveComponent("phone-icon");

  return _openBlock(), _createElementBlock(_Fragment, null, [!$data.cookiePermissions ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.cookieConfirm && $options.cookieConfirm(...args))
  }, " Ok ")])])])) : _createCommentVNode("", true), _createElementVNode("footer", _hoisted_5, [_ctx.can('isGuest') ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createVNode(_component_router_link, {
    to: {
      name: 'sign-in'
    },
    class: "button"
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  })])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_router_link, {
    to: {
      name: 'main'
    },
    class: "footer-logo"
  }, {
    default: _withCtx(() => [_createVNode(_component_logo_icon, {
      width: "170",
      height: "auto"
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_ctx.can('isGuest') ? (_openBlock(), _createBlock(_component_login_button_component, {
    key: 0
  })) : _createCommentVNode("", true)]), _ctx.can('isGuest') ? (_openBlock(), _createBlock(_component_registration_button_component, {
    key: 0,
    class: "registration-button"
  })) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("ul", _hoisted_18, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'authors'
    }
  }, {
    default: _withCtx(() => [_hoisted_19]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'works'
    }
  }, {
    default: _withCtx(() => [_hoisted_20]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'compilations'
    }
  }, {
    default: _withCtx(() => [_hoisted_21]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'what-offer'
    }
  }, {
    default: _withCtx(() => [_hoisted_22]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'sell-work'
    }
  }, {
    default: _withCtx(() => [_hoisted_23]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'about'
    }
  }, {
    default: _withCtx(() => [_hoisted_24]),
    _: 1
  })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
    to: {
      name: 'contacts'
    }
  }, {
    default: _withCtx(() => [_hoisted_25]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("a", _hoisted_27, [_createVNode(_component_phone_icon, {
    style: {
      "margin-right": "1em"
    }
  }), _hoisted_28])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_ctx.can('isGuest') ? (_openBlock(), _createBlock(_component_login_button_component, {
    key: 0
  })) : _createCommentVNode("", true)]), _ctx.can('isGuest') ? (_openBlock(), _createBlock(_component_registration_button_component, {
    key: 0,
    class: "registration-button"
  })) : _createCommentVNode("", true)])])])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, " © " + _toDisplayString($data.year) + " Novene. Все права защищены. ", 1), _hoisted_35])])])])], 64);
}